export default __webpack_public_path__ + "static/media/web-development.924aefcd.png";